import { WidgetData } from '@playbooks/core/src/interfaces'

import { AiTeammateWidgetData, AiTeammateWidgetValue } from '../../types'
import { WidgetService } from './widgetService'

interface AiTeammateWidgetService extends WidgetService {
  /**
   * Set the value of the widget. Updates the timestamp as well.
   * @param value The new value
   */
  setValue(value: AiTeammateWidgetValue): void
}

/**
 * Create a Widget Service for an AI Teammate Widget
 * @param widget The widget data
 * @returns The Widget Service instance
 */
export const getAiTeammateWidgetService = (widget: WidgetData): AiTeammateWidgetService => {
  const aiTeammateWidget = widget as AiTeammateWidgetData

  return {
    setValue(value) {
      aiTeammateWidget.value = value
      aiTeammateWidget.updatedAt = Date.now()
    },
  }
}
